<template>
    <component
        :is="listType"
        class="icon-list"
    >
        <li
            v-for="(item, index) in items"
            :key="index"
            class="icon-list__item"
        >
            <div class="icon-list__icon">
                <BaseIcon
                    :icon="item.icon"
                />
            </div>
            <p
                class="icon-list__description"
            >
                {{ item.description }}
            </p>
        </li>
    </component>
</template>

<script setup>
defineProps({
    items: {
        type: Array,
        required: false,
        default() {
            return [];
        }
    },
    listType: {
        type: String,
        required: false,
        default: 'ul'
    }
});
</script>

<style lang="less" src="./IconList.less"></style>
